import { useState } from "react";
import { Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout, TableCard } from "ui-components/Layout";
import { AddButton, EditButton } from "ui-components/IconButton";
import { Error_ } from "ui-components/Alert";
import { getWarehouseList } from "services/data.internal.service";
import { useTeamValue } from "providers/TeamContext";
import { useCustomerValue } from "providers/CustomerContext";

function WarehouseList() {
  const {permissions, allowAll} = useTeamValue();
  const {customerCode} = useCustomerValue()
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Warehouse"]) && permissions["Warehouse"].findIndex(b => b==="new") !== -1);
  const editPermission = allowAll || (Boolean(permissions["Warehouse"]) && permissions["Warehouse"].findIndex(b => b==="edit") !== -1);
  const deactivatePermission = allowAll || (Boolean(permissions["Warehouse"]) && permissions["Warehouse"].findIndex(b => b==="deactivate") !== -1);
  const addZonePermission = allowAll || (Boolean(permissions["Zone"]) && permissions["Zone"].findIndex(b => b==="new") !== -1);
  useQuery({
    queryKey: ["warehouse-list", {customerCode}],
    queryFn: () => getWarehouseList({customerCode}),
    onSuccess: (data) => setData(data.data.data),
    enabled:Boolean(customerCode),
    onError,
  });

  const onNew = () => navigate("/setup/warehouse/add");

  const onEdit = (req) => navigate("/setup/warehouse/edit", { state: req });

  const onAdd = (req) => navigate("/setup/zone/add", { state: req });

  const columns = [
    { header: "Warehouse Code", accessorKey: "warehouseCode" },
    { header: "Descriptions 1", accessorKey: "descriptions1" },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { warehouseCode } = row.original;
        return (
          <>
            <EditButton title="edit warehouse" disabled={!editPermission} onClick={() => onEdit({ warehouseCode })} />
            <AddButton title="create zone" disabled={!addZonePermission} onClick={() => onAdd({ warehouseCode })} />
          </>
        );
      },
    },
  ];
  return (
    <ListLayout>
      <MDBox my={3}>
        {alert}
        <TableCard>
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            margin="10px"
          >
            <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
              <Icon>add</Icon>&nbsp;warehouse
            </MDButton>
          </MDBox>
          <BasicTable columns={columns} data={data} />
        </TableCard>
      </MDBox>
    </ListLayout>
  );
}

export default WarehouseList;
